import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ComponentRef,
    DestroyRef,
    EnvironmentInjector,
    EventEmitter,
    InjectionToken,
    Injector,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    Provider,
    Type,
    ViewContainerRef,
    inject,
    viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ICompetitionFilter } from '../../../index';
import { type DefaultCompetitionFilterComponent } from '../../../index';

export const CompetitionFilterComponentToken = new InjectionToken<DefaultCompetitionFilterComponent & Type<any>>('CompetitionFilterComponentToken');

export function provideCompetitionFilterComponent(component: typeof DefaultCompetitionFilterComponent): Provider {
    return { provide: CompetitionFilterComponentToken, useValue: component } as Provider;
}
@Component({
    selector: 'competition-filter',
    template: `<ng-container #baseRef></ng-container>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class CompetitionFilterComponent implements AfterViewInit, OnChanges, OnDestroy {
    private injector = inject(Injector);
    private envInjector = inject(EnvironmentInjector);
    private destroyRef = inject(DestroyRef);
    private readonly vcr = viewChild.required('baseRef', { read: ViewContainerRef });
    private cmpToken = inject(CompetitionFilterComponentToken);
    private cmpRef?: ComponentRef<any>;

    @Input() filter: ICompetitionFilter;
    @Output() readonly filterChange: EventEmitter<ICompetitionFilter> = new EventEmitter<ICompetitionFilter>();
    ngOnChanges() {
        this.syncInputs();
    }
    ngAfterViewInit() {
        if (!this.cmpToken) {
            throw new Error('Please provide a competition filter component!');
        }
        this.cmpRef = this.vcr().createComponent(this.cmpToken, {
            injector: this.injector,
            environmentInjector: this.envInjector,
        });
        this.syncInputs();
        if (this.cmpRef) {
            this.cmpRef.instance.filterChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x: ICompetitionFilter) => {
                this.filterChange.emit(x);
            });
        }
    }
    private syncInputs() {
        if (this.cmpRef) {
            this.cmpRef.setInput('filter', this.filter);
        }
    }
    ngOnDestroy(): void {
        this.cmpRef && this.cmpRef.destroy();
    }
}
